export class DashboardRoutesModel {
    driver: DriverModel;
    date: string;
    truckType: string;
    notes: string;
}

export class DriverModel {
    id: string;
    fName: string;
    lName: string;
    email: string;
    phone: string;
}

export class Device {
    tankId: Array<string> = [];
    tankName: Array<string> = [];
    product: Array<string> = [];
    capacity: Array<string> = [];
    ullage: Array<string> = [];
}